import React from 'react';
import PropTypes from 'prop-types';
import style from './style.module.scss';

/**
 * Title: Component Renders the NotebookContent Section Title
 */
export function Title({title}) {
  return (
    <div className={style.titleWrap}>
      <h2>{title}</h2>
    </div>
  );
}

Title.propTypes = {
  /**
   * Title to be displayed Content Section
   */
  title: PropTypes.string.isRequired,
};

Title.defaultProps = {
  title: '',
};
